// extracted by mini-css-extract-plugin
module.exports = {"root":"📦ConfirmChangeAsset__root--2EWn0","asset":"📦ConfirmChangeAsset__asset--2s6Dh","colorDanger":"📦ConfirmChangeAsset__colorDanger--3IzMR"};